module.exports = __webpack_public_path__ + "img/u20.d636c917.png";